import { Component } from '@angular/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { DialogActionService } from 'src/app/Services/dialog-actions.service';

// @Component({
//   selector: 'g10-ms-dialog',
//   templateUrl: './dialog.component.html',
//   styleUrls: ['./dialog.component.css']
// })
// export class DialogComponent implements OnInit {

//   language = 'html';
//   content = '<p>test</p>';

//   constructor(
//     public dialogRef: MatDialogRef<DialogComponent>,
//     // @Inject(MAT_DIALOG_DATA) public modalData: any,

//     public modalData: any,
//     private modalService: DialogActionService
//   ) {
//     // console.log(modalData);
//   }

//   ngOnInit() { }

//   // When the user clicks the action button, the modal calls the service\
//   // responsible for executing the action for this modal (depending on\
//   // the name passed to `modalData`). After that, it closes the modal
//   actionFunction() {

//     // this.modalService.modalAction(this.modalData);
//     this.closeModal();
//   }

//   // If the user clicks the cancel button a.k.a. the go back button, then\
//   // just close the modal
//   closeModal() {
//     this.dialogRef.close();
//   }

// }


@Component({
  selector: 'g10-ms-dialog',
  templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css']
})

export class DialogComponent{
    

}